import { Group, Layer } from 'react-konva';
import React from 'react';
import { getGroundTextColor } from 'models/ground';
import { PlayersMarkersProps } from 'types/webPlayer';
import Path from './Path';
import Marker from './Marker';
import { DEFAULT_GROUND_COLOR } from '../track/ground/constants';
import ErrorGuard from 'components/layout/ErrorGuard';

const PlayersMarkers = ( props: PlayersMarkersProps ) => {
  const {
    activePlayer,
    bearing,
    hoverPlayer,
    cursor,
    dataGround,
    enabledPlayers,
    infoPlayers,
    jerseyOrNumber,
    onPlayerClick,
    onPlayerDblClick,
    onPlayerEnter,
    onPlayerLeave,
    playersColors,
    playersDetails,
    playersPoints,
    scale,
    series,
    speedMultiplier,
    teamColors,
    trailsEnabled,
    groundSurfaceColor,
    userUnits,
    playersTeams,
  } = props;

  return (
    <Layer id="layer-players-markers">
      {
        enabledPlayers
        .map((playerID) => (
          playersPoints && playersPoints[playerID] && (
            <ErrorGuard key={playerID}>
              <Group>
                <Marker
                  active={activePlayer === playerID}
                  bearing={bearing}
                  hover={hoverPlayer === playerID}
                  color={
                    playersColors[playerID]
                      ? playersColors[playerID]
                      : playersTeams.listA && playersTeams.listA.includes(playerID)
                        ? teamColors.teamA
                        : teamColors.teamB
                  }
                  textColor={groundSurfaceColor === 'rgb(0,221,181)' || groundSurfaceColor === DEFAULT_GROUND_COLOR
                    ? '#004d41'
                    : '#fff'}
                  cursor={cursor}
                  id={playerID}
                  onClick={onPlayerClick}
                  onDblClick={onPlayerDblClick}
                  onMouseEnter={onPlayerEnter}
                  onMouseLeave={onPlayerLeave}
                  playerPoint={playersPoints[playerID]}
                  scale={scale}
                  showExtraData={infoPlayers.includes(playerID)}
                  speedMultiplier={speedMultiplier}
                  text={
                    playersDetails[playerID]
                      ? String(playersDetails[playerID][jerseyOrNumber ? 'shortName' : 'number'] || '---')
                      : '---'
                  }
                  userUnits={userUnits}
                />
                {
                  trailsEnabled
                  && (
                    <Path
                      bearing={bearing}
                      cursor={cursor}
                      dataGround={dataGround}
                      pathData={series[playerID]}
                      scale={scale}
                      pathColor={getGroundTextColor(groundSurfaceColor)}
                    />
                  )
                }
              </Group>
            </ErrorGuard>
          ) || null
        ))
      }
    </Layer>
  );
};

export default PlayersMarkers;
